module.exports = __webpack_public_path__ + "img/imag1.098f8a5d.png";